import React from 'react';
import styled from 'styled-components';
import { Skeleton as AntdSkeleton } from 'antd';
import { SkeletonImageProps as AntdSkeletonImageProps } from 'antd/lib/skeleton/Image';

export type SkeletonImageProps = Omit<AntdSkeletonImageProps, 'active'>;

export const SkeletonImage = styled(({ ...props }: SkeletonImageProps) => <AntdSkeleton.Image {...props} />)``;

export default SkeletonImage;
